import './MainImg.css';

export default function MainImg() {
  return (
    <div className="main-container">
      <img
        src="/assets/images/Struct.jpg"
        alt="Body"
        className="struct-image"
      />
      <h1 className="struct-title">
        Structural <br/> Engineering
      </h1>
    </div>
  );
}
